// extracted by mini-css-extract-plugin
export var actions = "_g6-g";
export var benefitCard = "_g6-b";
export var benefitIcon = "_g6-d";
export var benefitLabel = "_g6-f";
export var benefits = "_g6-a";
export var benefitsSection = "_g6-8";
export var bodyText = "_g6-7";
export var closeButton = "_g6-2";
export var content = "_g6-3";
export var eyebrow = "_g6-4";
export var heading = "_g6-5";
export var image = "_g6-i";
export var imagePanel = "_g6-h";
export var modal = "_g6-0";
export var offerCard = "_g6-c";
export var offerIcon = "_g6-e";
export var sectionLabel = "_g6-9";
export var shell = "_g6-1";
export var title = "_g6-6";